

export class AllocatedPortDataInput implements IAllocatedPortDataInput {
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId!: number;

    constructor(data?: IAllocatedPortDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortAllocationId = _data["deviceModelPortAllocationId"];
        }
    }

    static fromJS(data: any): AllocatedPortDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatedPortDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortAllocationId"] = this.deviceModelPortAllocationId;
        return data; 
    }
}

export interface IAllocatedPortDataInput {
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId: number;
}

